import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "../styles/SinavCoz.css";

const SinavCoz = () => {
    const { kullaniciSinavId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const token = localStorage.getItem("token");
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const kayitliSinavState = (() => {
        try {
            return JSON.parse(
                sessionStorage.getItem(`sinavState_${kullaniciSinavId}`)
            );
        } catch {
            return null;
        }
    })();

    const sinavState = location.state || kayitliSinavState || {};

    const {
        sinavBaslik = "Sınav",
        toplamSoru: baslangicToplamSoru,
        kalanSureSaniye: baslangicKalanSure,
        soruIdleri = [],
    } = sinavState;

    const [aktifIndex, setAktifIndex] = useState(0);
    const [soru, setSoru] = useState(null);
    const [cevaplar, setCevaplar] = useState([]);
    const [soruMedyaUrl, setSoruMedyaUrl] = useState(null);
    const [cevapMedyaMap, setCevapMedyaMap] = useState({});
    const [loading, setLoading] = useState(false);
    const [hata, setHata] = useState("");
    const [sinavSonuc, setSinavSonuc] = useState(null);
    const [showSonucPopup, setShowSonucPopup] = useState(false);
    const [bitirLoading, setBitirLoading] = useState(false);
    const [showCikisUyari, setShowCikisUyari] = useState(false);
    const [cevaplananSorular, setCevaplananSorular] = useState([]);

    const aktifSinavIcerikId = soruIdleri[aktifIndex];

    const [cevapKaydetLoading, setCevapKaydetLoading] = useState(false);
    const [soruAcilisZamani, setSoruAcilisZamani] = useState(null);

    const [kalanSure, setKalanSure] = useState(
        baslangicKalanSure || 0
    );

    const getAuthHeader = () => ({
        Authorization: `Bearer ${token}`,
    });

    const medyaBlobCek = async (url) => {
        const res = await axios.get(url, {
            headers: getAuthHeader(),
            responseType: "blob",
        });

        return URL.createObjectURL(res.data);
    };

    useEffect(() => {
        if (kalanSure === 0) return;

        const interval = setInterval(() => {
            setKalanSure((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);

                    bitirSinav();

                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [kalanSure]);

    useEffect(() => {
        const handleBrowserBack = () => {
            setShowCikisUyari(true);

            setTimeout(() => {
                window.history.pushState(null, "", window.location.href);
            }, 0);
        };

        window.history.pushState(null, "", window.location.href);
        window.addEventListener("popstate", handleBrowserBack);

        return () => {
            window.removeEventListener("popstate", handleBrowserBack);
        };
    }, []);

    useEffect(() => {
        return () => {
            if (soruMedyaUrl) URL.revokeObjectURL(soruMedyaUrl);

            Object.values(cevapMedyaMap).forEach((item) => {
                if (item?.url) URL.revokeObjectURL(item.url);
            });
        };
    }, [soruMedyaUrl, cevapMedyaMap]);

    useEffect(() => {
        if (!token) {
            navigate("/profil");
            return;
        }

        if (!aktifSinavIcerikId) {
            setHata("Soru listesi bulunamadı. Lütfen sınavı tekrar başlatın.");
            return;
        }

        fetchSoruDetay();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [aktifIndex, aktifSinavIcerikId]);

    const fetchSoruDetay = async () => {
        try {
            setLoading(true);
            setHata("");

            if (soruMedyaUrl) URL.revokeObjectURL(soruMedyaUrl);
            Object.values(cevapMedyaMap).forEach((item) => {
                if (item?.url) URL.revokeObjectURL(item.url);
            });

            setSoru(null);
            setCevaplar([]);
            setSoruMedyaUrl(null);
            setCevapMedyaMap({});

            const res = await axios.get(
                `${apiBaseUrl}/api/KullaniciSinav/sorudetay/${kullaniciSinavId}/${aktifSinavIcerikId}`,
                {
                    headers: getAuthHeader(),
                }
            );

            const gelenSoru = res.data;
            const gelenCevaplar = gelenSoru?.cevaplar?.$values || [];

            setSoru(gelenSoru);
            setCevaplar(gelenCevaplar);
            setSoruAcilisZamani(new Date());

            if (gelenSoru?.seciliCevapId) {
                soruCevaplandiOlarakIsaretle(gelenSoru.sinavIcerikId);
            }
            
            if (gelenSoru?.soruMedyaTipi) {
                const medyaUrl = await medyaBlobCek(
                    `${apiBaseUrl}/api/KullaniciSinav/sorumedya/${gelenSoru.soruId}`
                );

                setSoruMedyaUrl(medyaUrl);
            }

            const medyaMap = {};

            for (const cevap of gelenCevaplar) {
                if (cevap?.medyaTipi) {
                    const cevapMedyaUrl = await medyaBlobCek(
                        `${apiBaseUrl}/api/KullaniciSinav/cevapmedya/${cevap.id}`
                    );

                    medyaMap[cevap.id] = {
                        url: cevapMedyaUrl,
                        tip: cevap.medyaTipi,
                    };
                }
            }

            setCevapMedyaMap(medyaMap);
        } catch (err) {
            console.error("Soru detayı alınamadı:", err);
            setHata("Soru yüklenirken bir hata oluştu.");
        } finally {
            setLoading(false);
        }
    };

    const medyaGoster = (url, tip, className) => {
        if (!url || !tip) return null;

        if (tip === "image") {
            return <img src={url} alt="Soru medyası" className={className} />;
        }

        if (tip === "video") {
            return (
                <video className={className} controls>
                    <source src={url} />
                    Tarayıcınız video oynatmayı desteklemiyor.
                </video>
            );
        }

        return null;
    };

    const formatSure = (saniye) => {
        const dk = Math.floor(saniye / 60);
        const sn = saniye % 60;

        return `${dk}:${sn.toString().padStart(2, "0")}`;
    };

    const kritik = kalanSure < 60;

    const oncekiSoru = () => {
        if (aktifIndex > 0) {
            setAktifIndex((prev) => prev - 1);
        }
    };

    const sonrakiSoru = () => {
        if (aktifIndex < soruIdleri.length - 1) {
            setAktifIndex((prev) => prev + 1);
        }
    };

    const soruCevaplandiOlarakIsaretle = (sinavIcerikId) => {
        if (!sinavIcerikId) return;

        setCevaplananSorular((prev) => {
            if (prev.includes(sinavIcerikId)) return prev;
            return [...prev, sinavIcerikId];
        });
    };
    const handleCevapSec = async (cevap) => {
        if (!soru || !cevap || cevapKaydetLoading) return;

        try {
            setCevapKaydetLoading(true);

            const now = new Date();

            const gecenSaniye = soruAcilisZamani
                ? Math.max(0, Math.floor((now - soruAcilisZamani) / 1000))
                : 0;

            const payload = {
                kullaniciSinavId: Number(kullaniciSinavId),
                sinavIcerikId: soru.sinavIcerikId,
                secilenCevapId: cevap.id,
                cevapBaslamaTarihi: soruAcilisZamani
                    ? soruAcilisZamani.toISOString()
                    : now.toISOString(),
                cevaplamaSuresiSaniye_IlkGorulus: gecenSaniye,
                cevaplamaSuresiSaniye_SonAcilis: gecenSaniye,
            };

            console.log("Cevap kaydet payload:", payload);

            await axios.post(
                `${apiBaseUrl}/api/KullaniciSinav/cevapkaydet`,
                payload,
                {
                    headers: getAuthHeader(),
                }
            );

            setSoru((prev) => ({
                ...prev,
                seciliCevapId: cevap.id,
            }));
            soruCevaplandiOlarakIsaretle(soru.sinavIcerikId);
        } catch (err) {
            console.error("Cevap kaydedilemedi:", err);
        } finally {
            setCevapKaydetLoading(false);
        }
    };

    const bitirSinav = async () => {
        if (bitirLoading || showSonucPopup) return;

        try {
            setBitirLoading(true);

            const res = await axios.post(
                `${apiBaseUrl}/api/KullaniciSinav/bitir/${kullaniciSinavId}`,
                {},
                {
                    headers: getAuthHeader(),
                }
            );

            console.log("Sınav bitir response:", res.data);

            setSinavSonuc(res.data);
            setShowSonucPopup(true);
        } catch (err) {
            console.error("Sınav bitirilemedi:", err);
        } finally {
            setBitirLoading(false);
        }
    };

    return (
        <div className="sinav-coz-page">
            <div className="sinav-coz-header">
                <div>
                    <h1>{sinavBaslik}</h1>
                    <p>
                        Soru {aktifIndex + 1} / {baslangicToplamSoru || soru?.toplamSoru || soruIdleri.length}
                    </p>
                </div>

                <button
                    className="sinav-coz-back-btn"
                    onClick={() => setShowCikisUyari(true)}
                >
                    Profile Dön
                </button>
            </div>

            {hata && <div className="sinav-coz-hata">{hata}</div>}

            {loading && <div className="sinav-coz-loading">Soru yükleniyor...</div>}

            {!loading && soru && (
                <div className="sinav-main-layout">
                    <aside className="sinav-soru-takip-panel">
                        <h3>Sorular</h3>

                        <div className="sinav-soru-takip-list">
                            {soruIdleri.map((sinavIcerikId, index) => {
                                const cevaplandi = cevaplananSorular.includes(sinavIcerikId);
                                const aktif = aktifIndex === index;

                                return (
                                    <button
                                        key={sinavIcerikId}
                                        type="button"
                                        className={`sinav-soru-takip-btn ${cevaplandi ? "cevaplandi" : ""
                                            } ${aktif ? "aktif" : ""}`}
                                        onClick={() => setAktifIndex(index)}
                                    >
                                        {index + 1}
                                    </button>
                                );
                            })}
                        </div>
                    </aside>

                    <div className="sinav-soru-card">
                        <div className="sinav-soru-top">
                            <span className="sinav-soru-no">
                                {soru.aktifSiraNo}. Soru
                            </span>

                            <div className={`sinav-sure-box ${kritik ? "kritik" : ""}`}>
                                ⏱ {formatSure(kalanSure)}
                            </div>

                            <span className="sinav-soru-puan">
                                {soru.puan} Puan
                            </span>
                        </div>

                        <h2 className="sinav-soru-metni">{soru.soruMetni}</h2>

                        {medyaGoster(soruMedyaUrl, soru.soruMedyaTipi, "sinav-soru-medya")}

                        <div className="sinav-cevap-listesi">
                            {cevaplar.map((cevap, index) => (
                                <button
                                    key={cevap.id}
                                    className={`sinav-cevap-card ${soru.seciliCevapId === cevap.id ? "secili" : ""
                                        }`}
                                    type="button"
                                    onClick={() => handleCevapSec(cevap)}
                                    disabled={cevapKaydetLoading}
                                >
                                    <span className="sinav-cevap-harf">
                                        {String.fromCharCode(65 + index)}
                                    </span>

                                    <div className="sinav-cevap-icerik">
                                        <span>{cevap.metin}</span>

                                        {cevapMedyaMap[cevap.id] &&
                                            medyaGoster(
                                                cevapMedyaMap[cevap.id].url,
                                                cevapMedyaMap[cevap.id].tip,
                                                "sinav-cevap-medya"
                                            )}
                                    </div>
                                </button>
                            ))}
                        </div>

                        <div className="sinav-coz-actions">
                            <button
                                className="sinav-nav-btn secondary"
                                onClick={oncekiSoru}
                                disabled={aktifIndex === 0}
                            >
                                Önceki
                            </button>

                            {aktifIndex === soruIdleri.length - 1 ? (
                                <button
                                    className="sinav-nav-btn bitir"
                                    onClick={bitirSinav}
                                    disabled={bitirLoading}
                                >
                                    {bitirLoading ? "Bitiriliyor..." : "Sınavı Bitir"}
                                </button>
                            ) : (
                                <button
                                    className="sinav-nav-btn"
                                    onClick={sonrakiSoru}
                                >
                                    Sonraki
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {showSonucPopup && sinavSonuc && (
                <div className="sinav-sonuc-overlay">
                    <div className="sinav-sonuc-popup">
                        <h2>
                            {sinavSonuc.gectiMi
                                ? "Tebrikler, sınavı geçtiniz"
                                : "Sınav tamamlandı"}
                        </h2>

                        <p className={sinavSonuc.gectiMi ? "sonuc-gecti" : "sonuc-kaldi"}>
                            {sinavSonuc.gectiMi ? "GEÇTİ" : "KALDI"}
                        </p>

                        <div className="sinav-sonuc-grid">
                            <div>
                                <span>Toplam Soru</span>
                                <strong>{sinavSonuc.toplamSoru}</strong>
                            </div>

                            <div>
                                <span>Cevaplanan</span>
                                <strong>{sinavSonuc.cevaplananSoru}</strong>
                            </div>

                            <div>
                                <span>Boş</span>
                                <strong>{sinavSonuc.bosSoru}</strong>
                            </div>

                            <div>
                                <span>Doğru</span>
                                <strong>{sinavSonuc.dogruSayisi}</strong>
                            </div>

                            <div>
                                <span>Yanlış</span>
                                <strong>{sinavSonuc.yanlisSayisi}</strong>
                            </div>

                            <div>
                                <span>Puan</span>
                                <strong>{sinavSonuc.toplamPuan}</strong>
                            </div>

                            <div>
                                <span>Geçme Puanı</span>
                                <strong>{sinavSonuc.gecmePuani}</strong>
                            </div>
                        </div>

                        <button
                            className="sinav-sonuc-btn"
                            onClick={() => {
                                sessionStorage.removeItem(`sinavState_${kullaniciSinavId}`);
                                navigate("/profil", { replace: true });
                            }}
                        >
                            Tamam
                        </button>
                    </div>
                </div>
            )}

            {showCikisUyari && (
                <div className="sinav-cikis-overlay">
                    <div className="sinav-cikis-popup">
                        <h2>Sınavdan çıkmak üzeresiniz</h2>

                        <p>
                            Eğer profile dönerseniz sınavınız geçersiz sayılır. Başka giriş
                            hakkınız yoksa bu sınava tekrar giriş yapamayabilirsiniz.
                        </p>

                        <p className="sinav-cikis-vurgu">
                            Devam etmek istediğinize emin misiniz?
                        </p>

                        <div className="sinav-cikis-actions">
                            <button
                                className="sinav-cikis-cancel"
                                onClick={() => setShowCikisUyari(false)}
                            >
                                Vazgeç
                            </button>

                            <button
                                className="sinav-cikis-confirm"
                                onClick={() => {
                                    setShowCikisUyari(false);
                                    navigate("/profil", { replace: true });
                                }}
                            >
                                Onaylıyorum
                            </button>
                        </div>
                    </div>
                </div>
            )}



        </div>
    );

};

export default SinavCoz;